export const shouldForwardProp = (propName: string): boolean =>
  !/^\$.*/.test(propName);
